import Component from '../core/Component'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-open',
}

export default class Slideshow extends Component {
    prepare() {
        let current = 0
        let slides = document.getElementsByClassName('Landing-image')

        setInterval(function () {
            for (var i = 0; i < slides.length; i++) {
                slides[i].style.opacity = 0
            }
            current = current != slides.length - 1 ? current + 1 : 0
            slides[current].style.opacity = 1
        }, 3000)
    }
}
